(function () {
  'use strict';

  var pendingImages = new WeakMap();

  function setSelectedState(card, swatch) {
    card.querySelectorAll('[data-card-swatch]').forEach(function (item) {
      var selected = item === swatch;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function activateSwatch(swatch) {
    var card = swatch.closest('.card-m');
    if (!card || swatch.classList.contains('is-active')) return;

    var image = card.querySelector('.card-m__img--main');
    var source = swatch.dataset.imageSrc;
    if (!image || !source) return;

    setSelectedState(card, swatch);

    var requestId = (pendingImages.get(card) || 0) + 1;
    pendingImages.set(card, requestId);

    var preload = new Image();
    preload.decoding = 'async';
    preload.sizes = image.sizes || '100vw';
    if (swatch.dataset.imageSrcset) preload.srcset = swatch.dataset.imageSrcset;
    preload.src = source;

    var reveal = function () {
      if (pendingImages.get(card) !== requestId) return;
      image.decoding = 'async';
      if (preload.srcset) image.srcset = preload.srcset;
      image.src = preload.currentSrc || preload.src;
      if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;
      pendingImages.delete(card);
    };

    if (typeof preload.decode === 'function') {
      preload.decode().then(reveal, reveal);
    } else {
      preload.onload = reveal;
      preload.onerror = reveal;
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-card-swatch]');
    if (swatch) activateSwatch(swatch);
  });
})();
